/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Explainer_Local_SaveInputs */



/**
* | output |
* | --- |
* | "Changes are saved on this device and uploaded when you're back online." |
*
* @param {Offline_Explainer_Local_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_explainer_local_save = /** @type {((inputs?: Offline_Explainer_Local_SaveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Explainer_Local_SaveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les modifications sont enregistrées sur cet appareil et envoyées à votre retour en ligne.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los cambios se guardan en este dispositivo y se suben cuando vuelva a estar en línea.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As mudanças são salvas neste dispositivo e enviadas quando você voltar a ficar online.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le modifiche sono salvate su questo dispositivo e inviate quando torna online.")
	return /** @type {LocalizedString} */ ("Changes are saved on this device and uploaded when you're back online.")
});